const SET_UNIQUE_ID = 'SET_UNIQUE_ID';
const UNIQUE_ID_FETCH_ERROR = 'UNIQUE_ID_FETCH_ERROR';
const SET_MESSAGING_UNIQUE_ID = 'SET_MESSAGING_UNIQUE_ID';
const MESSAGING_UNIQUE_ID_FETCH_ERROR = 'MESSAGING_UNIQU_ID_FETCH_ERROR';
const SET_MAUID = 'SET_MAUID';
const MAUID_FETCH_ERROR = 'MAUID_FETCH_ERROR';
export {
  SET_UNIQUE_ID,
  UNIQUE_ID_FETCH_ERROR,
  SET_MESSAGING_UNIQUE_ID,
  SET_MAUID,
  MESSAGING_UNIQUE_ID_FETCH_ERROR,
  MAUID_FETCH_ERROR,
};
